import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import 'animate.css';
Vue.prototype.$axios=axios
// Vue.prototype.$baseUrl='http://8.129.71.194:8890'
import 'normalize.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
